import { useEffect, useRef, useState } from "react";
import "react-grid-layout/css/styles.css";
import { useNavigate } from "react-router-dom";
import AccessTemplateSelection from "../../../../components/BuilderComponents/AccessTemplateSelection";
import ChipList from "../../../../components/BuilderComponents/ChipList";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import NotesAndTags from "../../../../components/BuilderComponents/NotesAndTags";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import Button from "../../../../components/FormComponents/Button";
import ErrorMessage from "../../../../components/FormComponents/ErrorMessage";
import Input from "../../../../components/FormComponents/Input";
import MultiRadio from "../../../../components/FormComponents/MultiRadio";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Textarea from "../../../../components/FormComponents/Textarea";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import { useAuth0Context } from "../../../../context/Auth0Context";
import { useModalContext } from "../../../../context/ModalContext";
import { useTableContext } from "../../../../context/TableContext";
import { useTreeContext } from "../../../../context/TreeDataContext";
import useZTheme from "../../../../hooks/useZTheme";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../../Layouts/PageInfoAndActionBar";
import axiosInstance, { handleApiError } from "../../../../services/axiosService";
import { elementConfig } from "../../../../utils/Config/DefaultConfig/elementConfig";
import { isValidObjectId } from "../../../../utils/objectIdUtils";
import { toastError, toastSuccess } from "../../../../utils/toastUtils";
import PositionScreenWithEdit from "../../../FlexibleLayout/PositionScreenWithEdit";
import {
  findItemById,
  getOffset,
  getPositionedElementConfig,
  getScreenWidth,
  updateOnlyElementConfigInLayout
} from "../../../FlexibleLayout/utils";
import { RVCAtalogViewForPostioned } from "../../RecordsViewRenderer/Desktop/PositionedDesktopRecordview";
import DetailsviewElementsBar from "./DetailsviewElementsBar";
import { DetailviewEditActions } from "./DetailviewHeader";
import DetailviewLayoutEditor from "./DetailviewLayoutEditor";
const DetailviewDesktopRenderer = () => {
  const { applicationBlockData } = useAppBlocksContext();
  if (applicationBlockData.is_positioned_block) {
    return <PositionedDetailsViewComponent />;
  }
  return <NonPositionedDatailsViewComponent />;
};

function getWidth(device, dvSize = "", position_block_metadata = {}) {
  const width = getScreenWidth({ device, metadata: position_block_metadata });
  if (device === "desktop") {
    const size = dvSize.toLowerCase();
    return size === "large" ? 1000 : size === "medium" ? 750 : size === "small" ? 400 : width;
  }
  return width;
}

export const getActivityCardData = (applicationBlockData, blocksExplorerData) => {
  const deviceData = blocksExplorerData.find((block) => block.id === applicationBlockData.device);
  if (!deviceData) return [];
  const activityCardBlock = deviceData.items.find((block) => block.name === "activitycard");
  return activityCardBlock?.items || [];
};

export const getActivityBlocksData = (applicationBlockData, blocksExplorerData) => {
  const deviceData = blocksExplorerData.find((block) => block.id === applicationBlockData.device);
  if (!deviceData) return [];

  const recordsViewBlock = deviceData.items.find((block) => block.name === "recordsview");
  const allRecordsview = recordsViewBlock?.items || [];
  const activityRecordviews = allRecordsview.filter((rv) => rv.type === "activity");

  const chartBlock = deviceData.items.find((block) => block.name === "chart");
  const allCharts = chartBlock?.items || [];
  const activityCharts = allCharts.filter((chart) => chart.type === "activity");

  const progressBarBlock = deviceData.items.find((block) => block.name === "progress-bar");
  const progressBarItems = progressBarBlock?.items || [];

  return [...activityRecordviews, ...activityCharts, ...progressBarItems];
};

const NonPositionedDatailsViewComponent = () => {
  const { applicationBlockData, setSelectedAppBlock } = useAppBlocksContext();
  const { blocksExplorerData } = useTreeContext();
  const { device } = applicationBlockData;
  const navigate = useNavigate();
  const { getTableTypeData } = useTableContext();
  const tableRef = useRef({});
  const [dragFromOutside, setDragFromOutside] = useState(false);

  const fetchCurrentSmData = async () => {
    try {
      const { tableObject } = await getTableTypeData(
        applicationBlockData.table_type,
        applicationBlockData.data.table_id
      );
      // await checkLock();
      tableRef.current = { ...tableObject };
    } catch (error) {
      handleApiError(error.message);
      navigate("../");
      setSelectedAppBlock({ id: "", name: "", parentData: "", table_id: "", activity_id: "" });
    }
  };

  const handleDragStart = (e, name, id, type) => {
    setDragFromOutside(true);
    e.dataTransfer.setData("id", id);
    e.dataTransfer.setData("type", type);
    e.dataTransfer.setData("name", name);
  };

  useEffect(() => {
    if (applicationBlockData.id) {
      fetchCurrentSmData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationBlockData.id]);
  return (
    <div className="detailsView_outer_body">
      <div className="detailsView_main_section">
        <PageInfoAndActionBarForDetailsview />
        {/* <DetailviewInfoBar saveBlock={handleSaveApplicationBlock} cloneBlock={handleCloneApplicationBlock} /> */}
        <div className="desktop_draggable_field_outer">
          <div
            id="droppableContainerWidth"
            className={
              device === "mobile"
                ? "screen_header_draggable_outer position-screen-mobile-preview-outer"
                : "droppable_container border_radius_medium"
            }
            style={{
              width: applicationBlockData.device === "mobile" ? "50%" : "100%"
              // padding: "0px 20px 20px 20px"
            }}
          >
            <DetailviewLayoutEditor
              dragFromOutside={dragFromOutside}
              setDragFromOutside={setDragFromOutside}
              tableRef={tableRef}
              device={applicationBlockData.device}
              tableID={applicationBlockData.data.table_id}
              tableType={applicationBlockData.table_type}
              activityID={applicationBlockData.data?.activity_id}
              elements={[applicationBlockData]}
              variables={applicationBlockData.data.variables}
              headerComponent={<DetailviewEditActions />}
            />
          </div>
        </div>
      </div>
      <DetailsviewElementsBar
        handleDragStart={handleDragStart}
        activityCardsData={getActivityCardData(applicationBlockData, blocksExplorerData)}
        activityBlocksData={getActivityBlocksData(applicationBlockData, blocksExplorerData)}
        isPositionedScreen={false}
      />
    </div>
  );
};

const PositionedDetailsViewComponent = () => {
  const { applicationBlockData, layoutConfig, setLayoutConfig } = useAppBlocksContext();
  useZTheme(applicationBlockData.device);
  const { blocksExplorerData } = useTreeContext();
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [draggedItem, setDraggedItem] = useState(null);
  const [catalogWidth, setCatalogWidth] = useState(0);
  const [catalogLayoutConfig, setCatalogLayoutConfig] = useState([]);
  const initModalState = {
    isOpen: false,
    type: "",
    name: ""
  };
  const [modalState, setModalState] = useState(initModalState);
  const openModal = (type, name) => setModalState({ isOpen: true, type, name });
  const closeModal = () => setModalState(initModalState);

  const initialCatalogPlaygroundState = {
    show: false,
    type: "",
    elementId: "",
    fieldId: "",
    fieldType: ""
  };
  const [isCatalogEditPlaygroundOpen, setIsCatalogEditPlaygroundOpen] = useState(initialCatalogPlaygroundState);

  const openCatalogPlayground = (type, elementId, fieldId, fieldType, cardWidth, layout) => {
    setIsCatalogEditPlaygroundOpen({
      show: true,
      type,
      elementId,
      fieldId,
      fieldType
    });
    setCatalogWidth(cardWidth);
    setCatalogLayoutConfig(layout || []);
  };

  const closeCatalogEditPlayground = () => {
    setIsCatalogEditPlaygroundOpen(initialCatalogPlaygroundState);
  };

  const handleDragStart = (e, name, id, type) => {
    type = type === "empty" ? "field" : type;
    let newConfig = getPositionedElementConfig(type, applicationBlockData.device);
    if (newConfig.type === "element") {
      if (
        type === "activitycard" ||
        type === "activity-recordsview" ||
        type === "progress-bar" ||
        type === "custom-component"
      ) {
        newConfig.config = {
          type,
          id
        };
      } else {
        newConfig.config = elementConfig[type === "tableview" ? "table" : type];
      }
    }

    const offset = getOffset(e);
    setDraggedItem(newConfig);
    setDragOffset(offset);
  };

  useEffect(() => {
    if (!isCatalogEditPlaygroundOpen.show || !catalogLayoutConfig) return;

    const tableElement = findItemById(layoutConfig, isCatalogEditPlaygroundOpen.elementId);
    if (!tableElement) return;

    const fieldConfig = JSON.parse(JSON.stringify(tableElement.config)) || {};
    fieldConfig.catalog = fieldConfig.catalog || {};
    fieldConfig.catalog.layout = catalogLayoutConfig || [];

    const newLayoutConfig = updateOnlyElementConfigInLayout(
      layoutConfig,
      isCatalogEditPlaygroundOpen.elementId,
      fieldConfig
    );

    setLayoutConfig(newLayoutConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogLayoutConfig, isCatalogEditPlaygroundOpen.show]);

  if (isCatalogEditPlaygroundOpen.show) {
    return (
      <RVCAtalogViewForPostioned
        width={catalogWidth}
        height={"100%"}
        layoutConfig={catalogLayoutConfig}
        setLayoutConfig={setCatalogLayoutConfig}
        device={applicationBlockData.device}
        tableId={applicationBlockData.data.table_id}
        tableType={applicationBlockData.table_type}
        elements={[applicationBlockData]}
        onClose={closeCatalogEditPlayground}
        targetFolderPath={[isCatalogEditPlaygroundOpen.fieldId]}
      />
    );
  }

  return (
    <div className="detailsView_outer_body">
      <div className="detailsView_main_section screen-center-wrapper position_relative">
        <PageInfoAndActionBarForDetailsview />

        <PositionedDetailsLayoutEdit
          dragOffset={dragOffset}
          draggedItem={draggedItem}
          setDragOffset={setDragOffset}
          setDraggedItem={setDraggedItem}
          openCatalogPlayground={openCatalogPlayground}
        />
        <div className="ai_bot_icon" onClick={() => openModal("ai", "Create Detailview With AI")}>
          <MaterialIcon name="smart_toy" />
        </div>
      </div>
      <DetailsviewElementsBar
        handleDragStart={handleDragStart}
        activityCardsData={getActivityCardData(applicationBlockData, blocksExplorerData)}
        activityBlocksData={getActivityBlocksData(applicationBlockData, blocksExplorerData)}
        isPositionedScreen={true}
      />
      <BuilderModal modalName={modalState.name} isOpen={modalState.isOpen} onClose={closeModal}>
        <BlockCreationWithAI tableId={applicationBlockData.data.table_id} tableType={applicationBlockData.table_type} />
      </BuilderModal>
    </div>
  );
};

const PositionedDetailsLayoutEdit = ({
  dragOffset,
  setDragOffset,
  draggedItem,
  setDraggedItem,
  openCatalogPlayground
}) => {
  const { applicationBlockData, layoutConfig, setLayoutConfig } = useAppBlocksContext();
  const { device, position_block_metadata = {}, detailview_settings = {} } = applicationBlockData;
  const [selectedItem, setSelectedItem] = useState(null);

  // const [screenLayoutInfo, setScreenLayoutInfo] = useState({
  //   showGrid: true,
  //   showTree: false,
  //   showTemplate: false,
  //   screenMode: "editable",
  //   scaleFactor: 1,
  //   gridSize: (() => {
  //     if (device === "desktop") {
  //       return 8;
  //     } else {
  //       return position_block_metadata?.grid_size || 4;
  //     }
  //   })()
  // });

  const handleClick = (item, info) => {
    if (info && info.type && info.type === "catalog_edit") {
      const actualItem = findItemById(layoutConfig, item.id);

      const catalog = actualItem?.config?.catalog ?? {};
      const cardsPerRow = catalog.cards_per_row ?? 1;
      const gapBetweenCards = parseInt(catalog.gap_between_cards ?? 18);

      const totalWidth = parseInt(actualItem.style.width) - (cardsPerRow - 1) * gapBetweenCards;
      const cardWidth = Math.floor(totalWidth / cardsPerRow);

      openCatalogPlayground(info.type, actualItem.id, info.field_id, info.field_type, cardWidth, catalog.layout || []);
    }
  };

  // const handleChangeLayoutInfo = (type, value) => {
  //   setScreenLayoutInfo({ ...screenLayoutInfo, [type]: value });
  // };

  // const containerClass =
  //   device === "mobile"
  //     ? "position-screen-mobile-preview-outer mobile_screen border_radius_medium"
  //     : "position-screen-preview-outer  border_radius_medium screen_header_draggable_outer";

  return (
    <>
      <div className="page-action-bar-top">
        <DetailviewEditActions />
        {/* <PositionScreenActionBar
          screenLayoutInfo={screenLayoutInfo}
          setScreenLayoutInfo={setScreenLayoutInfo}
          device={device}
        /> */}
      </div>

      <div className="position-screen-center-page ">
        <PositionScreenWithEdit
          layoutConfig={layoutConfig || []}
          setLayoutConfig={setLayoutConfig}
          draggedItem={draggedItem}
          setDragOffset={setDragOffset}
          setDraggedItem={setDraggedItem}
          dragOffset={dragOffset}
          // type={screenLayoutInfo.showTemplate ? "view" : screenLayoutInfo.screenMode}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          // gridSize={screenLayoutInfo.gridSize}
          screenWidth={getWidth(device, detailview_settings.size || "", position_block_metadata)}
          // showTree={screenLayoutInfo.showTree}
          // setShowTree={() => setScreenLayoutInfo({ ...screenLayoutInfo, showTree: false })}
          // showGrid={screenLayoutInfo.showGrid}
          tableId={applicationBlockData.data.table_id}
          tableType={applicationBlockData.table_type}
          device={applicationBlockData.device}
          buttonElements={[applicationBlockData]}
          onClick={handleClick}
          // scaleFactor={screenLayoutInfo.scaleFactor}
        />
        {/* <BuilderModal
          isOpen={screenLayoutInfo.showTemplate}
          onClose={() => handleChangeLayoutInfo("showTemplate", false)}
          modalName="Templates"
          customStyleClsName="template_modal_fullsize"
          bodyStyle={{ minHeight: "100vh", overflow: "auto" }}
        >
          <PositionedTemplateList />
        </BuilderModal> */}
      </div>
    </>
  );
};

// const DetailviewInfoBar = ({ saveBlock, cloneBlock }) => {
//   const { layout, layoutData, nestedGridData, applicationBlockData, setApplicationBlockData, lockData, setLockData } =
//     useAppBlocksContext();
//   const { user } = useAuth0Context();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isSettingOpen, setIsSettingOpen] = useState(false);

//   const handletoggleLock = async () => {
//     try {
//       if (lockData && lockData.user_id) {
//         if (lockData.user_id !== user.sub) {
//           toastError("Unauthorized");
//           return;
//         }
//         const { message } = await axiosInstance.delete(`/app/lock/${applicationBlockData.id}`);
//         toastSuccess(message);
//         setLockData({});
//       } else {
//         const userinfo = `${user.first_name} (${user.email})`;
//         const lock = {
//           type: "detailview",
//           user_id: user.sub,
//           user_info: userinfo,
//           type_id: applicationBlockData.id,
//           type_name: applicationBlockData.name
//         };
//         const { message } = await axiosInstance.post(`/app/lock`, lock);
//         toastSuccess(message);
//         setLockData(lock);
//       }
//     } catch (error) {
//       handleApiError(error);
//     }
//   };
//   const handleChange = (data, key) => {
//     const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
//     copyBlockData[key] = data;

//     setApplicationBlockData(copyBlockData);
//   };

//   const handleNotesAndTag = (data, keyName) => {
//     const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
//     copyBlockData[keyName] = data;
//     setApplicationBlockData(copyBlockData);
//   };

//   return (
//     <div className="screen_save_container">
//       <PageInfoAndActionBar
//         pagePath={`Blocks/${applicationBlockData.data?.activity_id ? "Activity Card" : "Detailsview"}/${
//           applicationBlockData.name
//         }`}
//         currentConfig={[layout, nestedGridData.current, layoutData.current, applicationBlockData]}
//         pageName={"applicationblock"}
//         savePage={saveBlock}
//         clonePage={cloneBlock}
//         toggleLock={handletoggleLock}
//         isLocked={lockData?.user_id || null}
//         importSomething={() => setIsModalOpen({ type: "template", modal_name: "Import Template" })}
//         notesPage={() => setIsModalOpen({ type: "note", modal_name: "Notes and tags" })}
//         settingPage={() => setIsSettingOpen(true)}
//       />

//       <BuilderModal
//         isOpen={isModalOpen.type}
//         onClose={() => setIsModalOpen({ type: "" })}
//         modalName={isModalOpen.modal_name}
//       >
//         {isModalOpen.type === "note" && (
//           <NotesAndTags
//             notesValue={applicationBlockData.description || ""}
//             tagValue={applicationBlockData.info_tag || []}
//             onChange={handleNotesAndTag}
//           />
//         )}
//         {isModalOpen.type === "owner" && (
//           <AccessTemplateSelection templates={applicationBlockData.access_templates} handleChange={handleChange} />
//         )}
//       </BuilderModal>

//       <BuilderModal
//         isOpen={isModalOpen.type === "template"}
//         onClose={() => setIsModalOpen({ type: "" })}
//         modalName={isModalOpen.modal_name}
//       >
//         {isModalOpen.type === "template" && <TemplateModal closeModal={() => setIsModalOpen({ type: "" })} />}
//       </BuilderModal>

//       <BuilderModal isOpen={isSettingOpen} onClose={() => setIsSettingOpen(false)} modalName="Settings">
//         <DetailviewSettings
//           template={applicationBlockData.access_templates}
//           blockSetting={{
//             show_print: applicationBlockData.detailview_settings?.show_print || false,
//             size: applicationBlockData.detailview_settings?.size || "",
//             print_custom_css: applicationBlockData.detailview_settings?.print_custom_css || ""
//           }}
//           handleChange={handleChange}
//         />
//       </BuilderModal>
//     </div>
//   );
// };

const DetailviewSettings = ({ blockSetting, handleChange }) => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    setSettings(blockSetting);
  }, [blockSetting]);

  const handleInputChange = (event) => {
    const { type, name, value, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;

    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: newValue
    }));

    handleChange({ ...settings, [name]: newValue }, "detailview_settings");
  };

  const sizeOptions = [
    { id: "", name: "Default" },
    { id: "small", name: "small" },
    { id: "medium", name: "medium" },
    { id: "large", name: "large" }
  ];
  return (
    <div className="builder_form">
      {/* <AccessTemplateSelection templates={template} handleChange={(data) => handleChange(data, "access_templates")} /> */}

      <MultiRadio
        keyName="size"
        selectedValue={settings.size}
        options={sizeOptions}
        onChange={handleInputChange}
        label="Detailview Size"
      />

      <div className="center_container ">
        <Input type="checkbox" name="show_print" checked={settings.show_print} onChange={handleInputChange} />
        <label className="builder_label mb_0">Show Print</label>
      </div>
      <div className="builder_form">
        <Textarea
          label="Print Css"
          value={settings.print_custom_css}
          name="print_custom_css"
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

const PageInfoAndActionBarForDetailsview = () => {
  const {
    applicationBlockData,
    layout,
    layoutData,
    nestedGridData,
    handleSaveApplicationBlock,
    lockData,
    setLockData,
    handleCloneApplicationBlock,
    setApplicationBlockData
  } = useAppBlocksContext();
  const { user } = useAuth0Context();

  const initialModalState = {
    isOpen: false,
    type: "",
    name: ""
  };
  const [modalState, setModalState] = useState(initialModalState);

  const openModal = (type, name) => {
    setModalState({ isOpen: true, type, name });
  };
  const closeModal = () => {
    setModalState(initialModalState);
  };

  const handletoggleLock = async () => {
    try {
      if (lockData && lockData.user_id) {
        if (lockData.user_id !== user.sub) {
          toastError("Unauthorized");
          return;
        }
        const { message } = await axiosInstance.delete(`/app/lock/${applicationBlockData.id}`);
        toastSuccess(message);
        setLockData({});
      } else {
        const userinfo = `${user.first_name} (${user.email})`;
        const lock = {
          type: "detailview",
          user_id: user.sub,
          user_info: userinfo,
          type_id: applicationBlockData.id,
          type_name: applicationBlockData.name
        };
        const { message } = await axiosInstance.post(`/app/lock`, lock);
        toastSuccess(message);
        setLockData(lock);
      }
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleChange = (data, key) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[key] = data;

    setApplicationBlockData(copyBlockData);
  };
  return (
    <>
      <PageInfoAndActionBar
        pagePath={`Blocks/Detailsview/${applicationBlockData.name}`}
        currentConfig={[layout, nestedGridData.current, layoutData.current, applicationBlockData]}
        pageName={"applicationblock"}
        savePage={handleSaveApplicationBlock}
        clonePage={handleCloneApplicationBlock}
        toggleLock={handletoggleLock}
        isLocked={lockData?.user_id || null}
        notesPage={() => openModal("notes", "Notes and tags")}
        settingPage={() => openModal("settings", "Settings")}
      />

      <BuilderModal isOpen={modalState.isOpen} onClose={closeModal} modalName={modalState.name}>
        {modalState.type === "settings" && (
          <>
            <AccessTemplateSelection
              templates={applicationBlockData.access_templates}
              handleChange={(data) => handleChange(data, "access_templates")}
            />
            <DetailviewSettings
              blockSetting={{
                show_print: applicationBlockData.detailview_settings?.show_print || false,
                size: applicationBlockData.detailview_settings?.size || "",
                print_custom_css: applicationBlockData.detailview_settings?.print_custom_css || ""
              }}
              handleChange={handleChange}
            />
          </>
        )}
        {modalState.type === "notes" && (
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleChange}
          />
        )}
      </BuilderModal>
    </>
  );
};

const CreateAiTemplateForBlocks = ({
  selectedFields,
  removeFields,
  openModal,
  addAllActivityField,
  cleareAllFields,
  userPrompt,
  setUserPrompt,
  createAiHtml,
  isLoading,
  htmlData,
  setIsSaveModalOpen,
  error,
  modalState,
  closeModal,
  addNewField,
  tableId,
  tableType,
  isSaveModalOpen,
  saveTemplate
}) => {
  const noFieldsSelected = selectedFields.length === 0;

  return (
    <div className="flex_column h_100">
      <div className="py_3">
        <div className="d_flex gap_2 align_center flex_wrap">
          <ChipList chips={selectedFields} labelKey={["label"]} removeChip={removeFields} />
          {noFieldsSelected && (
            <div style={{ color: "#888", fontStyle: "italic", fontSize: "14px" }}>
              No fields selected. Click "+ Add Field" to begin.
            </div>
          )}
          <div className="d_flex gap_2 align_center flex_wrap">
            <Button variant="secondary" size="small" onClick={() => openModal("field", "Select Field")}>
              + Add Field
            </Button>
            <Button variant="secondary" size="small" onClick={addAllActivityField}>
              + Add All Fields
            </Button>
            <Button variant="secondary" size="small" onClick={cleareAllFields}>
              Clear All
            </Button>
          </div>
        </div>

        <div className="d_flex gap_4 align_end justify_end mt_3">
          <textarea
            id="userPrompt"
            value={userPrompt}
            onChange={(e) => setUserPrompt(e.target.value)}
            placeholder="Enter a custom prompt for AI to generate template"
            rows="3"
            style={{ width: "100%", marginTop: "10px", padding: "8px", borderRadius: "4px" }}
          />
          <Button onClick={createAiHtml} isLoading={isLoading} variant={htmlData ? "secondary" : "primary"}>
            {htmlData ? "Regenerate" : "Generate"}
          </Button>
          {htmlData && <Button onClick={() => setIsSaveModalOpen(true)}>Save</Button>}
        </div>
      </div>

      {error && <ErrorMessage className="d_flex align_center h_100 justify_center">{error}</ErrorMessage>}
      {!error && !htmlData && (
        <div className="d_flex align_center h_100 justify_center">Please generate the template to preview it.</div>
      )}
      {htmlData && (
        <div className="h_100">
          <IframeRenderer html={htmlData} />
        </div>
      )}

      <BuilderModal isOpen={modalState.isOpen} onClose={closeModal} modalName={modalState.name}>
        <TableTreeModal callbackFunction={addNewField} tableId={tableId} tableType={tableType} />
      </BuilderModal>

      <BuilderModal isOpen={isSaveModalOpen} onClose={() => setIsSaveModalOpen(false)} modalName="Save Template">
        <SaveTemplateModal onSave={saveTemplate} />
      </BuilderModal>
    </div>
  );
};

const formatField = (field) => ({
  type: field.activity_label + "." + field.field_type,
  label: field.display,
  id: field.id
});

const BlockCreationWithAI = ({ tableId, tableType }) => {
  const [selectedFields, setSelectedFields] = useState([]);
  const [userPrompt, setUserPrompt] = useState("");
  const [htmlData, setHtmlData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { getTableTypeData } = useTableContext();

  const initModalState = { isOpen: false, type: "", name: "" };
  const [modalState, setModalState] = useState(initModalState);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);

  const openModal = (type, name) => setModalState({ isOpen: true, type, name });
  const closeModal = () => setModalState(initModalState);

  const removeFields = (removedField) => {
    setSelectedFields((prev) => prev.filter((f) => f.id !== removedField.id));
  };

  const addNewField = (newField) => {
    const formatted = formatField(newField);
    setSelectedFields((prev) => (prev.some((f) => f.id === formatted.id) ? prev : [...prev, formatted]));
  };

  const createAiHtml = async () => {
    setIsLoading(true);
    setError("");
    try {
      const payload = {
        required_form_field: selectedFields,
        sm_id: tableId,
        ai_model: "gemini",
        user_prompt: userPrompt
      };
      const { data } = await axiosInstance.post("/ai/detailsview/html", payload);
      setHtmlData(data.html_code);
      toastSuccess("HTML generated successfully!");
    } catch (err) {
      console.error(err);
      setError("Failed to generate HTML. Please try again.");
      handleApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const addAllActivityField = async () => {
    const { tableObject } = await getTableTypeData(tableType, tableId);
    const formattedFields = [];

    for (const key in tableObject) {
      if (isValidObjectId(key)) {
        const newField = tableObject[key];
        formattedFields.push(formatField(newField));
      }
    }

    setSelectedFields(formattedFields);
  };

  const cleareAllFields = () => {
    setSelectedFields([]);
  };

  const saveTemplate = async ({ name, description }) => {
    try {
      const payload = {
        name,
        description,
        type: "detailsview",
        table_id: tableId,
        table_type: tableType,
        data: {
          html: htmlData
        }
      };
      await axiosInstance.post("/ai-template", payload);
      toastSuccess("Template saved!");
      setIsSaveModalOpen(false);
    } catch (err) {
      console.error(err);
      handleApiError(err);
    }
  };

  return (
    <div className="flex_column" style={{ width: "70vw", height: "70vh" }}>
      <BuilderTabs
        tabs={[
          {
            label: "Create with AI",
            content: (
              <CreateAiTemplateForBlocks
                selectedFields={selectedFields}
                htmlData={htmlData}
                isLoading={isLoading}
                error={error}
                modalState={modalState}
                isSaveModalOpen={isSaveModalOpen}
                setIsSaveModalOpen={setIsSaveModalOpen}
                openModal={openModal}
                closeModal={closeModal}
                removeFields={removeFields}
                addNewField={addNewField}
                createAiHtml={createAiHtml}
                saveTemplate={saveTemplate}
                tableId={tableId}
                tableType={tableType}
                userPrompt={userPrompt}
                setUserPrompt={setUserPrompt}
                addAllActivityField={addAllActivityField}
                cleareAllFields={cleareAllFields}
              />
            )
          },
          {
            label: "Saved Templates",
            content: <SavedAiBlockTemplates tableId={tableId} />
          }
        ]}
        tabsClass={"activity_tab"}
        contentClass={"h_100"}
      />
    </div>
  );
};

const SavedAiBlockTemplates = ({ tableId }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { getUserConfirmationForDelete } = useModalContext();

  useEffect(() => {
    const fetchTemplates = async () => {
      setIsLoading(true);
      setError(""); // reset error
      try {
        const { data } = await axiosInstance.get(`/ai-template?table_id=${tableId}&type=detailsview`);
        setTemplates(data);
        if (data.length > 0) {
          setSelectedTemplate(data[0]); // Auto-select first template
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch templates. Please try again.");
        handleApiError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableId]);

  const handleDelete = async () => {
    if (!selectedTemplate) return;
    const userConfirmed = await getUserConfirmationForDelete(selectedTemplate.name);
    if (!userConfirmed) return;

    try {
      await axiosInstance.delete(`/ai-template/${selectedTemplate.id}`);
      const updatedTemplates = templates.filter((t) => t.id !== selectedTemplate.id);
      setTemplates(updatedTemplates);
      setSelectedTemplate(updatedTemplates.length > 0 ? updatedTemplates[0] : null);
    } catch (err) {
      console.error(err);
      handleApiError(err);
      setError("Failed to delete the template.");
    }
  };

  return (
    <div className="h_100 flex_column">
      {isLoading && <div>Loading templates...</div>}
      {error && <div className="text-red-600">{error}</div>}
      {!isLoading && templates.length === 0 && <div className="text-gray-500">No templates found for this table.</div>}
      {templates.length > 0 && (
        <>
          <div className="d_flex gap_3 align_end py_3">
            <SingleSelectBox
              options={templates}
              valueKey="id"
              labelKey={["name"]}
              selectedData={selectedTemplate}
              onChange={(selectedOption) => setSelectedTemplate(selectedOption)}
              label="Select Template"
              containerClassName="mb_0"
              containerStyle={{ width: "400px" }}
            />
            <Button variant="delete" style={{ marginLeft: "0" }} onClick={handleDelete}>
              Delete
            </Button>
          </div>
          {selectedTemplate?.data?.html && (
            <div style={{ width: "100%", height: "100%" }}>
              <IframeRenderer html={selectedTemplate.data.html} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

const IframeRenderer = ({ html }) => {
  return (
    <iframe
      title="Rendered HTML"
      srcDoc={html}
      sandbox="" // Optional: "allow-scripts" etc. based on your need
      style={{
        width: "100%",
        height: "100%", // You can make this dynamic later
        border: "1px solid #ccc",
        borderRadius: "8px"
      }}
    />
  );
};

const SaveTemplateModal = ({ onSave }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleSave = async () => {
    if (!name.trim()) return;
    await onSave({ name, description });
    setName("");
    setDescription("");
  };

  return (
    <div className="builder_form">
      <Input
        label="Template Name"
        placeholder="Enter template name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <Textarea
        label="Description"
        placeholder="Optional description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <Button onClick={handleSave} disabled={!name.trim()}>
        Save Template
      </Button>
    </div>
  );
};
export default DetailviewDesktopRenderer;
